export const formatFecha = (valor) => {
    if (!valor) return '—';
    const fecha = new Date(valor);
    if (isNaN(fecha.getTime())) return valor;
    return fecha.toLocaleString('es-CO', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });
};

export const claseMetodo = (metodo) => {
    switch (metodo) {
        case 'POST':
            return 'bg-success';
        case 'PUT':
        case 'PATCH':
            return 'bg-info';
        case 'DELETE':
            return 'bg-danger';
        default:
            return 'bg-secondary';
    }
};
